import { useLocation } from '@reach/router';
import { AppPath, SubscriptionTypes } from 'appConstants';
import { Package, Subjects } from 'pages/newSubscription/models';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectValidPromoCode } from 'reducers/misc';

import { SubscriptionDurationOptions } from './SubscriptionDurationOptions';

type Props = {
  subjectInfo: Subjects;
  selectPackage: (p: Package) => void;
  selectedPackages: Package[];
  ageGroup: string;
};

const PackageCard: React.FC<Props> = ({
  subjectInfo,
  selectPackage,
  selectedPackages,
  ageGroup,
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  const validPromoCode = useSelector(selectValidPromoCode);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [packageDuration, setPackageDuration] = useState<any>(null);

  useEffect(() => {
    const packageCardSelected = selectedPackages.find(
      (p: Package) => p.ageGroup === ageGroup && p.subject === subjectInfo.name
    );

    setIsChecked(packageCardSelected ? true : false);
    setPackageDuration(
      packageCardSelected &&
        packageCardSelected.type && packageDuration
        ? packageCardSelected.type
        : setFirstPackageHighlight()
    );
  }, [selectedPackages]);

  const togglePackageCard = () => {
    if (!isPackagedAvailable()) return;
    if (isChecked) setPackageDuration(setFirstPackageHighlight());
    setIsChecked((prevState) => !prevState);
    const selectedPackage = subjectInfo.subscriptions.find(
      (s: Package) => s.type === packageDuration
    );
    selectedPackage &&
      selectPackage({
        ...selectedPackage,
        ageGroup,
        subject: subjectInfo.name,
      });
  };

  const selectPackageDuration = (p: Package) => {
    setPackageDuration(p.type);
    setIsChecked(true);
    selectPackage({
      ...p,
      ageGroup,
      subject: subjectInfo.name,
    });
  };

  const setFirstPackageHighlight = () => {
    let firstPackageAvailable = subjectInfo.subscriptions.find(
      (s: Package) => s.isAvailableForSchool
    )?.type;

    return firstPackageAvailable ? firstPackageAvailable : subjectInfo.subscriptions[0].type;
  };

  let checkPackageAvailable = subjectInfo.subscriptions.find(
    (s: Package) => s.isAvailableForSchool
  ) ? true : false;

  const packagePrice = subjectInfo.subscriptions.find(
    (s: Package) => s.type === packageDuration
  )?.price;

  const isPackagedAvailable = () => {
    /*Check if the package is available to buy*/
    if (AppPath.SUBSCRIBE === pathname) return true;
    
    let isPackageAvailable = false;
    subjectInfo.subscriptions.map((s: Package) => {
      if(s.isAvailableForSchool){
        isPackageAvailable = !isPackageAvailable;
      }
    });

    return isPackageAvailable;
  };

  return (
    <div
      className={`PackageCard ${isChecked ? 'Checked' : 'Unchecked'} ${
        !isPackagedAvailable() && 'Disabled'
      }`}
    >
      <div className="CardContent" onClick={togglePackageCard}>
        <span className="Checkbox"></span>

        <div className="Details">
          <h3>{subjectInfo.name}</h3>
          <span>
            £{' '}
            {packageDuration && packagePrice}
          </span>
        </div>
      </div>

      <SubscriptionDurationOptions
        duration={packageDuration}
        toggleSubscriptionDuration={selectPackageDuration}
        subjectInfo={subjectInfo}
        checkPackageAvailable={checkPackageAvailable}
      />
    </div>
  );
};

export default PackageCard;
